'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _customHeader = require('../../custom-header');

var _customHeader2 = _interopRequireDefault(_customHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MPPSocialInnovationHeader = function (_React$Component) {
  _inherits(MPPSocialInnovationHeader, _React$Component);

  function MPPSocialInnovationHeader() {
    _classCallCheck(this, MPPSocialInnovationHeader);

    return _possibleConstructorReturn(this, (MPPSocialInnovationHeader.__proto__ || Object.getPrototypeOf(MPPSocialInnovationHeader)).apply(this, arguments));
  }

  _createClass(MPPSocialInnovationHeader, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_customHeader2.default, _extends({ className: 'pp-header--social-innovation' }, this.props));
    }
  }]);

  return MPPSocialInnovationHeader;
}(_react2.default.Component);

exports.default = MPPSocialInnovationHeader;


MPPSocialInnovationHeader.defaultProps = {
  className: 'pp-header--social-innovation',
  config: {
    useMinimalHeader: false
  },
  content: {
    minimalHeader: {
      labelMenuButton: 'Menu',
      labelClose: 'Close',
      logo: {
        text: 'PayPal',
        href: '/webapp/mpp/social-innovation"',
        subText: 'Social Innovation'
      }
    },
    mainMenuContent: [{
      type: 'linkOnly',
      text: 'Improving Financial Health',
      href: '/webapps/mpp/social-innovation/financial-health'
    }, {
      type: 'linkOnly',
      text: 'Powering Giving',
      href: '/webapps/mpp/social-innovation/powering-giving'
    }, {
      type: 'linkOnly',
      text: 'Strengthening Our Communities',
      href: '/webapps/mpp/social-innovation/strengthening-communities'
    }],
    sublistMobile: []
  }
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/social-innovation-header/jsx/MPPSocialInnovationHeader.js
// module id = 1143
// module chunks = 4